import "../App.css";

import { teamMemberData, partnersData } from "./components/teamMemberData";
import React from "react";
import TeamMember from "./components/TeamMember";
import i18next from "../i18n";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const history_image = require("../images/IMG_3854.JPG");
const history_image_2 = require("../images/IMG_4615.JPG");
const team_image = require("../images/IMG_4646.JPG");

import flexible_icon from "../images/illustrations/Fleksible_icon.svg";
import innovative_icon from "../images/illustrations/Innovative_icon.svg";
import profesional_icon from "../images/illustrations/Profesional_icon.svg";

function About() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.about.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.about.undertitle")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/om-xper"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 pb-24 justify-start items-start text-main-dark">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-2">
            {i18next.t("pages.about.title")}
          </h1>
          <p className="text-xl text-secondary mb-12">
            {i18next.t("pages.about.undertitle")}
          </p>

          <p className="text-xl">{i18next.t("pages.about.intro.p1")}</p>
          <p className="text-xl">{i18next.t("pages.about.intro.p2")}</p>
        </div>
      </div>

      <div className="container flex-col max-w-2xl mb-24">
        <h2 className="max-w-xs text-4xl font-bold text-main">
          {i18next.t("pages.about.values.title")}
        </h2>
        <div className="flex flex-row flex-wrap md:flex-nowrap justify-between my-8 gap-10 text-main-dark opacity-90">
          <div className="flex flex-col w-full md:w-1/3 min-w-[250px] items-center justify-between self-end">
            <img
              className="text-main-dark w-[130px]"
              src={flexible_icon}
              alt={i18next.t("pages.about.values.flexible.alt")}
            />
            <h3 className="text-3xl font-bold mb-2">
              {i18next.t("pages.about.values.flexible.title")}
            </h3>
          </div>
          <div className="flex flex-col w-full md:w-1/3 min-w-[250px] items-center self-end">
            <img
              className="text-white w-[130px]"
              src={innovative_icon}
              alt={i18next.t("pages.about.values.innovative.alt")}
            />
            <h3 className="text-3xl font-bold mb-2">
              {i18next.t("pages.about.values.innovative.title")}
            </h3>
          </div>
          <div className="flex flex-col w-full md:w-1/3 min-w-[250px] items-center self-end">
            <img
              className="text-gray w-[130px]"
              src={profesional_icon}
              alt={i18next.t("pages.about.values.professional.alt")}
            />
            <h3 className="text-3xl font-bold mb-2">
              {i18next.t("pages.about.values.professional.title")}
            </h3>
          </div>
        </div>
      </div>

      <div className="bg-gray">
        <div className="container flex-col max-w-2xl py-24 text-xl text-main-dark items-center text-left">
          <div className="max-w-sm mx-auto">
            <h2 className="text-3xl font-bold text-main-dark mb-6">
              {i18next.t("pages.about.future.title")}
            </h2>
            <p>{i18next.t("pages.about.future.description")}</p>
          </div>

          <div className="flex flex-col md:flex-row gap-10">
            <img
              src={history_image}
              alt="history"
              className="w-full md:w-2/3 h-[400px] object-cover rounded-3xl md:-mr-32 mt-12 z-10 relative"
            />
            <div className="max-w-sm bg-white rounded-3xl p-8 md:p-16 text-main-dark z-20 relative md:-ml-16 md:mt-32">
              <h2 className="text-3xl font-bold text-main-dark mb-4">
                {i18next.t("pages.about.differentiators.title")}
              </h2>

              <ul className="list-disc ml-6">
                <li className="mb-2">
                  <b>
                    {i18next.t("pages.about.differentiators.items.ccm.title")}:
                  </b>{" "}
                  {i18next.t(
                    "pages.about.differentiators.items.ccm.description"
                  )}
                </li>
                <li className="mb-2">
                  <b>
                    {i18next.t(
                      "pages.about.differentiators.items.expertise.title"
                    )}
                    :
                  </b>{" "}
                  {i18next.t(
                    "pages.about.differentiators.items.expertise.description"
                  )}
                </li>
                <li className="mb-2">
                  <b>
                    {i18next.t(
                      "pages.about.differentiators.items.stability.title"
                    )}
                    :
                  </b>{" "}
                  {i18next.t(
                    "pages.about.differentiators.items.stability.description"
                  )}
                </li>
                <li>
                  <b>
                    {i18next.t(
                      "pages.about.differentiators.items.accessibility.title"
                    )}
                    :
                  </b>{" "}
                  {i18next.t(
                    "pages.about.differentiators.items.accessibility.description"
                  )}
                </li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col md:flex-row flex-col-reverse w-full mt-24">
            <div className="max-w-sm bg-white rounded-3xl p-8 md:p-16 text-main-dark z-20 relative md:-mr-16 md:mt-44">
              <h2 className="text-3xl font-bold text-main-dark mb-4">
                {i18next.t("pages.about.culture.title")}
              </h2>
              <p>{i18next.t("pages.about.culture.description")}</p>
              <ul className="list-disc ml-6">
                <li className="mb-2">
                  <b>
                    {i18next.t("pages.about.culture.items.collaboration.title")}{" "}
                    –
                  </b>{" "}
                  {i18next.t(
                    "pages.about.culture.items.collaboration.description"
                  )}
                </li>
                <li className="mb-2">
                  <b>
                    {i18next.t("pages.about.culture.items.customer.title")} –
                  </b>{" "}
                  {i18next.t("pages.about.culture.items.customer.description")}
                </li>
                <li className="mb-2">
                  <b>
                    {i18next.t("pages.about.culture.items.innovation.title")} –
                  </b>{" "}
                  {i18next.t(
                    "pages.about.culture.items.innovation.description"
                  )}
                </li>
                <li>
                  <b>
                    {i18next.t("pages.about.culture.items.knowledge.title")} –
                  </b>{" "}
                  {i18next.t("pages.about.culture.items.knowledge.description")}
                </li>
              </ul>
            </div>
            <img
              src={history_image_2}
              alt="history"
              className="w-full md:w-1/2 h-[400px] object-cover rounded-3xl md:-ml-40 mb-12 z-10 relative"
            />
          </div>
          <div className="max-w-sm w-full mx-auto mt-24">
            <h3 className="text-3xl font-bold text-main-dark">
              {i18next.t("pages.about.futureVision.title")}
            </h3>
            <p>{i18next.t("pages.about.futureVision.description")}</p>
            <Button
              variant="solid"
              color="contrast"
              size="large"
              className="mt-6 ml-auto"
              onClick={() => {
                navigate("/skjema/kontakt-oss");
              }}
            >
              {i18next.t("pages.about.futureVision.cta")}
            </Button>
          </div>
        </div>
      </div>
      <div className="bg-white pb-36">
        <div className="container flex-col max-w-2xl py-36 justify-start">
          <h2 className="text-5xl font-bold text-main-dark mb-12">
            {i18next.t("pages.about.team.title")}
          </h2>
          <div className="flex flex-row flex-wrap justify-center gap-10">
            {teamMemberData.map((e, i) => (
              <TeamMember data={e} key={"teammember-" + i} />
            ))}
          </div>
          <h2 className="text-4xl font-bold text-main-dark mb-12 mt-10">
            {i18next.t("pages.about.team.linkNordic")}
          </h2>
          <div className="flex flex-row flex-wrap justify-center gap-10">
            {partnersData.map((e, i) => (
              <TeamMember data={e} key={"partner-" + i} />
            ))}
          </div>
        </div>
        <div className="container max-w-lg">
          <div className="w-full flex flex-col md:flex-row bg-gray rounded-3xl overflow-hidden">
            <div className="w-full md:w-2/5 bg-contrast relative order-2 md:order-1 h-[300px] md:h-auto">
              <img
                alt="bg"
                src={team_image}
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
            <div className="w-full md:w-3/5 p-14 text-main-dark order-1 md:order-2">
              <h2 className="text-5xl font-bold text-main-dark mb-6">
                {i18next.t("pages.about.team.join.title")}
              </h2>
              <p>{i18next.t("pages.about.team.join.description")}</p>
              <Button
                variant="solid"
                color="main"
                size="large"
                className="mt-6 ml-auto"
                onClick={() => {
                  navigate("/skjema/kontakt-oss");
                }}
              >
                {i18next.t("pages.about.team.join.cta")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
